import Button from '@/common/Button';
import { ReactElement } from 'react';
import Table from '@/common/Table';
import { useReportTable } from '@/pages/Reports/DynamicReport/components/ReportTable';

export type ReportTableHeaderProps = {
  columns?: Record<string, ReportTableHeaderColumn>;
  rows?: unknown[];
};
type ReportTableHeaderColumn = {
  name: string;
  description: string;
  value: string;
};

const ReportTableHeader = ({ columns, rows }: ReportTableHeaderProps): ReactElement => {
  const [{ sorting, onSort, expanded, onExpand }] = useReportTable(({ state, setState }) => {
    const currentRowIds = Array.from(
      new Set(
        rows
          .filter((row: any) => row?.['children']?.length > 0)
          .map((row: any) => state.getIds(row))
          .flat()
      )
    );
    const expanded = state.expanded.some((rowId) => currentRowIds.includes(rowId));
    return [
      {
        sorting: state.sorting,
        onSort: state.onSort,
        expanded,
        onExpand: () => {
          if (expanded) {
            setState((current) => ({
              ...current,
              expanded: Array.from(new Set([...current.expanded].filter((rowId) => !currentRowIds.includes(rowId)))),
            }));
          } else {
            setState((current) => {
              return {
                ...current,
                expanded: Array.from(new Set([...current.expanded, ...currentRowIds])),
              };
            });
          }
        },
      },
    ];
  });
  return (
    <Table.Row className="ReportTableHeader" header>
      <Table.Cell className="ReportTableCell SELECT">
        <Button onClick={onExpand} variant="text">
          <i className={`sv ${expanded ? 'sv-minus-square' : 'sv-plus-square'}`} />
        </Button>
      </Table.Cell>
      {columns &&
        Object.entries(columns).map(
          ([key, { name, description, value }]: [string, ReportTableHeaderColumn]): ReactElement => (
            <Table.Cell
              className={`ReportTableHeaderCell ${key.toUpperCase()}`}
              title={description || name}
              sorting={{ direction: sorting.sortBy === key ? sorting.direction : undefined, onSort: onSort(key) }}
              key={key}
            >
              {value}
            </Table.Cell>
          )
        )}
    </Table.Row>
  );
};

export default ReportTableHeader;
